/**
 * Runtime gate for the proactive version check. Disabled in dev — every vite
 * reload would look like a "new deploy". Lives in its own module so tests can
 * stub the flag without fighting vite's static import.meta.env replacement.
 */
export const isVersionCheckEnabled = () => !import.meta.env.DEV
